module.exports = __webpack_public_path__ + "media/images/design/common/images/cmn_btn_pagetop-a4ff3e408fe68a66f02b45c12e0a67da.png";